const PopularCities = ["Ahmedabad", "Bangalore", "Chennai", "Delhi", "Gurgaon", "Hyderabad", "Kolkata", "Mumbai", "Pune"];

const Company = {
    title: "COMPANY",
    links: ["About us", "Team", "Careers", "Swiggy Blog", "Bug Bounty", "Swiggy Super", "Swiggy Corporate"]
};

const Contact = {
    title: "CONTACT",
    links: ["Help & Support", "Partner with us", "Ride with us"]
};

const Legal = {
    title: "LEGAL",
    links: ["Terms & Conditions", "Refund & Cancellation", "Privacy Policy", "Cookie Policy", "Offer Terms"]
};

const DeliverTo = [
    ["Abohar",
        "Achalpur",
        "Adilabad",
        "Adityapur",
        "Adoni",
        "Agartala",
        "Agra",
        "Ahmedabad",
        "Ahmednagar",
        "Ajmer",
        "Akola",
        "Akot",
        "Alappuzha",
        "Aligarh",
        "Allahabad",
        "Alwar",
        "Amalner",
        "Ambala",
        "Ambikapur",
        "Ambur",
        "Amravati",
        "Amreli",
        "Amritsar",
        "Amroha",
        "Anand",
        "Anantapur",
        "Ankleshwar",
        "Arrah",
        "Asansol",
        "Ashoknagar",
        "Aurangabad",
        "Aurangabad_bihar",
        "Azamgarh",
        "Baddi",
        "Bagalkot",
        "Bagdogra",
        "Bahadurgarh",
        "Bahraich",
        "Bajpe",
        "Balaghat",
        "Ballari",
        "Ballarpur",
        "Balrampur",
        "Balurghat",
        "Bangalore",
        "Bangalore-Airport",
        "Bankura",
        "Banswara",
        "Bantwal",
        "Bapatlachirala",
        "Baramati",
        "Baraut",
        "Bardhaman",
        "Bardoli",
        "Bareilly",
        "Barnala",
        "Barshi",
        "Basirhat",
        "Basti",
        "Batala",
        "Bathinda",
        "Beawar",
        "Beed",
        "Begusarai",
        "Behror",
        "Belgaum",
        "Berhampore",
        "Berhampur",
        "Bettiah",
        "Betul",
        "Bhadrachalam",
        "Bhadravati",
        "Bhagalpur",
        "Bhandara",
        "Bharabanki",
        "Bharatpur",
        "Bharuch",
        "Bhatapara",
        "Bhatkal",
        "Bhavnagar",
        "Bhilai",
        "Bhilwara",
        "Bhimavaram",
        "Bhind",
        "Bhiwadi",
        "Bhiwani",
        "Bhopal",
        "Bhubaneswar",
        "Bhuj",
        "Bhusawal",
        "Bidar",
        "Biharsharif",
        "Bijapur",
        "Bijnor",
        "Bikaner",
        "Bilaspur",
        "Bina",
        "Bodhan-Rural",
        "Bokaro",
        "Bolpur",
        "Bongaigaon",
        "Bongaon",
        "Botad",
        "Budaun",
        "Budhwal",
        "Bulandshahr",
        "Buldana",
        "Bundi",
        "Burhanpur",
        "Buxar",
        "Central-Goa",
        "Chalakkudy",
        "Chalisgaon",
        "Chandigarh",
        "Chandrapur",
        "Changanasherry",
        "Charkhi-Dadri",
        "Chennai",
        "Cherthala",
        "Chhapra",
        "Chhatarpur",
        "Chhindwara",
        "Chikkaballapur",
        "Chikmagalur",
        "Chilakaluripet",
        "Chitradurga",
        "Chittoor",
        "Chittorgarh",
        "Churu",
        "Coimbatore",
        "Cuddalore",
        "Cuttack",
        "Dabhoi",
        "Dabra",
        "Dahod"],
        [
            "Damoh",
"Darbhanga",
"Darjeeling",
"Datia",
"Dausa",
"Davanagere",
"Dehradun",
"Dehri",
"Delhi",
"Deoghar",
"Dewas",
"Dhamtari",
"Dhanbad",
"Dhar",
"Dharamshala",
"Dharmapuri",
"Dharmavaram",
"Dharwad",
"Dhule",
"Dibrugarh",
"Digha",
"Dindigul",
"Doddaballapura",
"Duliajan",
"Durgapur",
"Eluru",
"Erode",
"Etawah",
"Faizabad",
"Faridabad",
"Faridkot",
"Farrukhabad",
"Fatehabad",
"Fatehgarh-Sahib",
"Fatehpur",
"Fazilka",
"Firozabad",
"Firozpur",
"Gadag-Betigeri",
"Gadwal",
"Gandhidham",
"Gaya",
"Gharaunda",
"Ghaziabad",
"Giridih",
"Godhra",
"Gohana",
"Gokak",
"Gokarna",
"Gonda",
"Gondal",
"Gondia",
"Gopalganj",
"Gorakhpur",
"Gudivada",
"Guna",
"Guntakal",
"Guntur",
"Gurdaspur",
"Gurgaon",
"Guwahati",
"Gwalior",
"Habra",
"Haldia",
"Haldwani",
"Halol",
"Hampi",
"Hansi",
"Hanumangarh",
"Hapur",
"Hardoi",
"Haridwar",
"Hassan",
"Himmatnagar",
"Hindupur",
"Hinganghat",
"Hisar",
"Hoshangabad",
"Hoshiarpur",
"Hospet",
"Hubli",
"Hyderabad",
"Ichalkaranji",
"Imphal",
"Indore",
"Irinjalakuda",
"Itarsi",
"Jabalpur",
"Jagdalpur",
"Jagraon",
"Jagtial",
"Jahanabad",
"Jaipur",
"Jalalabad",
"Jalandhar",
"Jalgaon",
"Jalna",
"Jalpaiguri",
"Jammu",
"Jamnagar",
"Jamshedpur",
"Janjgir",
"Jaunpur",
"Jhalawar",
"Jhansi",
"Jhunjhunu",
"Jind",
"Jodhpur",
"Jorhat",
"Junagadh",
"Kadapa",
"Kadiri",
"Kaithal",
"Kakinada",
"Kalaburagi",
"Kalady",
"Kamareddy",
"Kanchrapara",
"Kanker",
"Kannur",
"Kanpur",
"Kanyakumari",
"Kapurthala",
"Karad",
"Karaikkudi",
"Karimnagar",
"Karnal",
"Karunagappaly",
"Karur",
"Karwar",
"Kashipur",
"Katihar",
"Katni",
"Kavali",
"Kayamkulam",
        ],
        [
            "Khammam",
"Khandwa",
"Khanna",
"Kharagpur",
"Khargone",
"Kishanganj",
"Kishangarh",
"Kochi",
"Kodaikanal",
"Kolar",
"Kolhapur",
"Kolkata",
"Kollam",
"Korba",
"Kota",
"Kothagudem",
"Kothamanagalam",
"Kottarakkara",
"Kottayam",
"Kozhikode",
"Krishnagiri",
"Krishnanagar",
"Kuchaman",
"Kumbakonam",
"Kumta",
"Kundapura",
"Kurnool",
"Kurukshetra",
"Lakhimpur",
"Lalitpur",
"Latur",
"Lonavala",
"Lucknow",
"Ludhiana",
"Machilipatnam",
"Madanapalle",
"Madikeri",
"Madurai",
"Mahasamund",
"Mahbubnagar",
"Malappuram",
"Malda",
"Malegaon",
"Malout",
"Mancherial",
"Mandi-Dabwali",
"Mandsaur",
"Mandya",
"Mangaluru",
"Manipal",
"Mansa",
"Markapur",
"Mathura",
"Maunath-Bhanjan",
"Medak",
"Medinipur",
"Meerut",
"Mehsana",
"Miryalaguda",
"Mirzapur",
"Modinagar",
"Moga",
"Moodbidri",
"Moradabad",
"Morbi",
"Morbi-2",
"Morena",
"Motihari",
"Mount-Abu",
"Mughalsarai",
"Muktsar",
"Mumbai",
"Munger",
"Murdeshwar",
"Mussoorie",
"Muvattupuzha",
"Muzaffarnagar",
"Muzaffarpur",
"Mysore",
"Nabadwip",
"Nadiad",
"Nagaon",
"Nagapattinam",
"Nagda",
"Nagercoil",
"Nagpur",
"Nagur",
"Nainital",
"Nalgonda",
"Namakkal",
"Nanded",
"Nandurbar",
"Nandyal",
"Nangal",
"Naraingarh",
"Narasaraopet",
"Narnaul",
"Narwana",
"Nashik",
"Nathdwara",
"Navsari",
"Neemuch",
"Nellore",
"Neyveli",
"Nipani",
"Nirmal",
"Nizamabad",
"Noida",
"Noida-1",
"North-Goa",
"Ongole",
"Ooty",
"Orai",
"Osmanabad",
"Palakkad",
"Palanpur",
"Palasa",
"Pali",
"Palwal",
"Pandharpur",
"Panipat",
"Parbhani",
"Patan",
"Pathankot",
"Patiala",
"Patna",
"Phagwara",
"Phaltan",
"Pilani",
"Pilibhit",
"Pondicherry",
"Porbandar",
"Proddatur",
"Pudukkottai",
"Pune"
        ],
        [
            "Puri",
"Purnea",
"Purulia",
"Puttur",
"Rae-Bareli",
"Raichur",
"Raiganj",
"Raigarh",
"Raipur",
"Rajahmundry",
"Rajapalayam",
"Rajkot",
"Rajnandgaon",
"Ramagundam",
"Ramanathapuram",
"Ramgarh",
"Rampur",
"Ranchi",
"Ranibennur",
"Raniganj",
"Ratlam",
"Ratnagiri",
"Rayachoty",
"Rewa",
"Rewari",
"Rishikesh",
"Rohtak",
"Roorkee",
"Ropar",
"Rourkela",
"Rourkela-Do-Not-Use",
"Rudrapur",
"Sagar",
"Sagara",
"Saharanpur",
"Saharsa",
"Salem",
"Samastipur",
"Sambalpur",
"Sambhal",
"Sangamner",
"Sangaria",
"Sangli",
"Sangrur",
"Sardarshahar",
"Sasaram",
"Satara",
"Satna",
"Sawai-Madhopur",
"Sawantwadi",
"Sehore",
"Seoni",
"Shahjahanpur",
"Shillong",
"Shimla",
"Shirdi",
"Shivamogga",
"Shivpuri",
"Shrirampur",
"Siddipet",
"Sikar",
"Silchar",
"Siliguri",
"Sindhanur",
"Singrauli",
"Sirohi",
"Sirsa",
"Sirsi",
"Sitapur",
"Sivakasi",
"Sivasagar",
"Siwan",
"Solan",
"Solapur",
"Sonipat",
"South-Goa",
"Sri-Ganganagar",
"Srikakulam",
"Sultanpur",
"Surat",
"Suratgarh",
"Surendranagar-Dudhrej",
"Suryapet",
"Tadepalligudem",
"Tadpatri",
"Tamluk",
"Tanuku",
"Tarn-Taran-Sahib",
"Tezpur",
"Thalassery",
"Thanjavur",
"Theni",
"Thiruvalla",
"Thiruvallur",
"Thiruvananthapuram",
"Thodupuzha",
"Thoothukudi",
"Thrissur",
"Tinsukia",
"Tiptur",
"Tirunelveli",
"Tirupati",
"Tirupur",
"Tiruvannamalai",
"Tohana",
"Tonk",
"Trichy",
"Tumakuru",
"Tuni",
"Udaipur",
"Udgir",
"Ujjain",
"Uluberia",
"Unnao",
"Vadodara",
"Valsad",
"Vapi",
"Varanasi",
"Vellore",
"Veraval",
"Vidisha",
"Vijayawada",
"Viluppuram",
"Virudhunagar",
"Vizag",
"Vizianagaram",
"Vyara",
"Waidhan",
"Wani",
"Warangal",
"Wardha",
"Yamuna-Nagar",
"Yavatmal",
        ]
];

export {PopularCities, Company, Contact, Legal, DeliverTo};